import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { ArrowRight, Menu as MenuIcons, AreaIcon } from 'assets/icons';
import { HomeService, RevisionService, SignatureService, CallService } from 'services';
import { Input, RevisionItem as Item, Select } from 'components';
import { Modal } from 'components';
import ModalRating from './modal-rating';
import ModalUpload from '../revision/modal-upload';
import { ClientBanner, WhiteImage } from 'assets/img';
import ModalLawyers from './modal-lawyers';
import StatusCertificateCard from 'screens/apacuana/components/StatusCertificateCard';
import { useApacuana } from 'contexts/ApacuanaContext';
import { CERTIFICATES_TYPES } from 'screens/apacuana/utils';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
  apacuana?: any;
  customer?: any;
  status?: any;
  cert?: any;
  onOpenGenerateForm?: any;
  onOpenRevoqueForm?: any;
}

const TYPES = {
  REVISION: 1,
  SIGNATURE: 2,
  CALL: 3,
  PREPARATION: 4,
};

class Home extends React.Component<Props> {
  state = {
    plan_user: null,
    revisions: [],
    signatures: [],
    areas: [],
    calls: [],
    visible: false,
    type: null,
    item: null,
    visible_upload: false,
    visible_lawyer: false,
    // isLoadingSdkData: false, // Renombrado para evitar conflicto con loading de Redux/Servicios
    // certTypes: [],
    // hasFetchedCertTypes: false,
  };

  // componentDidUpdate(prevProps: Props) {
  //   const isInitialized = this.props.apacuana?.isInitialized ?? false;
  //   const { hasFetchedCertTypes } = this.state;

  //   // Condición: El SDK está inicializado Y NO hemos obtenido los datos aún
  //   if (isInitialized && !hasFetchedCertTypes) {
  //     // ********************************************************
  //     // ✅ CORRECCIÓN CLAVE: Romper el bucle inmediatamente.
  //     // ********************************************************
  //     // Esto le dice a React: "Ya estamos manejando esto, no vuelvas a entrar en el próximo render."
  //     this.setState({ hasFetchedCertTypes: true }, () => {
  //       // Llama al método asíncrono DENTRO del callback de setState
  //       // para que se ejecute después de que el estado haya cambiado.
  //       this.getCertTypesFromSdk();
  //     });

  //     // Llama a la inicialización de Apacuana (es opcional, si aún no se inicializó)
  //     const { initApacuanaSdk } = this.props.apacuana || {};
  //     if (initApacuanaSdk) {
  //       initApacuanaSdk(this.props.user?.apacuanaId);
  //     }

  //     console.log(
  //       "Apacuana SDK listo. Ejecutando lógica única (getCertTypes)."
  //     );
  //   }
  // }

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Inicio',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  getCertTypesFromSdk = async () => {
    // 1. Obtener el SDK del contexto inyectado
    const { sdk } = this.props.apacuana || {};
    // 2. Verificar disponibilidad del SDK
    if (!sdk) {
      console.warn('Apacuana SDK no disponible aún para getCertTypes.');
      return;
    }

    this.setState({ isLoadingSdkData: true });

    try {
      const certTypesList = await sdk.getCertTypes();
      this.setState({
        certTypes: certTypesList.data.records,
        hasFetchedCertTypes: true,
      });
    } catch (err: any) {
      console.error('Error al obtener los tipos de certificado:', err);
      this.setState({ hasFetchedCertTypes: true });
    } finally {
      this.setState({ isLoadingSdkData: false });
    }
  };

  load = async (withoutLoading = false) => {
    const [res, callsRes]: any = await Promise.all([
      HomeService.get({
        user_id: this.props.user?.id,
        withoutLoading,
      }),
      CallService.get({
        user_id: this.props.user?.id,
        page: 1,
        per_page: 3,
        withoutLoading,
      }),
    ]);
    this.setState({
      plan_user: res.plan_user,
      revisions: res.revisions || [],
      user: res.user,
      signatures: res.signatures || [],
      areas: res.areas || [],
      calls: callsRes.rows || [],
    });
    this.props.dispatch({
      type: 'SET_PLAN_USER',
      payload: res.plan_user || null,
    });
  };

  sendResponse = async (item: any, file: any, type: number) => {
    if (type == TYPES.REVISION) {
      await RevisionService.saveResponse({
        file,
        revision_id: item.id,
        hasFile: true,
      });
      Globals.showSuccess('Se ha enviado el archivo correctamente');
      this.load(true);
    } else if (type == TYPES.SIGNATURE) {
      await SignatureService.saveResponse({
        file,
        signature_id: item.id,
        hasFile: true,
      });
      Globals.showSuccess('Se ha enviado el archivo correctamente');
      this.load(true);
    }
  };

  onClose = () => {
    this.setState({
      visible: false,
      item: null,
    });
  };

  onCloseSearchLawyers = () => {
    this.setState({
      visible_lawyer: false,
    });
  };

  onOpenSearchLawyers = () => {
    this.setState({
      visible_lawyer: true,
    });
  };

  hasService = (serviceId: number) => {
    const services = (this.state.plan_user as any)?.membership?.membership_services || [];
    return services.some((s: any) => s.service_id === serviceId);
  };

  setApproved = (item: any, response: number, type: number) => {
    switch (response) {
      case Constants.REVISION_STATUS.ACCEPTED:
        Globals.confirm('¿Desea aprobar el archivo?', async () => {
          if (type == TYPES.REVISION) {
            await RevisionService.changeStatus({
              revision_id: item.id,
              status: Constants.REVISION_STATUS.ACCEPTED,
            });
          } else if (type == TYPES.SIGNATURE) {
            await SignatureService.changeStatus({
              signature_id: item.id,
              status: Constants.REVISION_STATUS.ACCEPTED,
            });
          }

          this.setState({
            item,
            type,
            visible: true,
          });

          this.load(true);
        });
        break;

      case Constants.REVISION_STATUS.REJECTED:
        Globals.confirm('¿Desea rechazar el archivo?', async () => {
          if (type == TYPES.REVISION) {
            await RevisionService.changeStatus({
              revision_id: item.id,
              status: Constants.REVISION_STATUS.REJECTED,
            });
          } else if (type == TYPES.SIGNATURE) {
            await SignatureService.changeStatus({
              signature_id: item.id,
              status: Constants.REVISION_STATUS.REJECTED,
            });
          }

          this.load(true);
        });
        break;
    }
  };

  onCloseUpload = () => {
    this.setState(
      {
        visible_upload: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  render() {
    const { visible, visible_upload, visible_lawyer } = this.state;
    const { user: apacuanaUser } = this.props.apacuana || {};
    const { customer, status, cert, onOpenGenerateForm, onOpenRevoqueForm } = this.props;

    return (
      <div id='client-home'>
        <Modal
          className='modal-rating'
          visible={visible}
          title='Calificar'
          onClose={() => this.onClose()}
        >
          {/*
		          // @ts-ignore */}
          <ModalRating
            item={this.state.item}
            type={this.state.type}
            onClose={() => this.onClose()}
          />
        </Modal>

        <Modal
          hideHeader={true}
          className='modal-lawyers'
          visible={visible_lawyer}
          title=''
          onClose={() => this.onCloseSearchLawyers()}
        >
          {/*
		          // @ts-ignore */}
          <ModalLawyers
            onClose={() => this.onCloseSearchLawyers()}
            navigation={this.props.history}
          />
        </Modal>

        <Modal
          className='modal-upload-document'
          visible={visible_upload}
          title='Aceptaron tu solicitud'
          onClose={() => this.onCloseUpload()}
        >
          {/*
		          // @ts-ignore */}
          <ModalUpload item={this.state.item} onClose={() => this.onCloseUpload()} />
        </Modal>

        <p className='name'>Hola, {this.props.user?.full_name}</p>

        <div className='row'>
          <div className='col-md-4'>
            <div className='container-white'>
              <div className='header-white'>
                <div className='name-container'>
                  <div className='icon-container' style={{ backgroundColor: Colors.orange }}>
                    <img src={MenuIcons.Menu6} />
                  </div>
                  <h3>Revisión documental</h3>
                </div>
                <Link to='/client/revision'>
                  Ver más <img src={ArrowRight} />
                </Link>
              </div>
              {this.state.revisions.length == 0 && (
                <div className='no-items'>
                  <p>No se encontraron registros</p>
                </div>
              )}
              {this.state.revisions.map((item: any) => {
                return (
                  <Item
                    openUpload={() => {
                      this.setState({
                        visible_upload: true,
                        item,
                      });
                    }}
                    sendResponse={(i: any, file: any) => this.sendResponse(i, file, TYPES.REVISION)}
                    setApproved={(item: any, response: number) =>
                      this.setApproved(item, response, TYPES.REVISION)
                    }
                    onRate={(item: any) =>
                      this.setState({ item, type: TYPES.REVISION, visible: true })
                    }
                    item={item}
                  />
                );
              })}
            </div>
            {this.state.plan_user && this.hasService(Constants.SERVICES.LAWYER_DIRECTORY) && (
              <div
                className='container-white container-banner'
                onClick={() => this.onOpenSearchLawyers()}
              >
                <img src={ClientBanner} />
              </div>
            )}
          </div>
          <div className='col-md-4'>
            <div className='container-white'>
              <div className='header-white'>
                <div className='name-container'>
                  <div className='icon-container' style={{ backgroundColor: Colors.danger }}>
                    <img src={MenuIcons.Menu12} />
                  </div>
                  <h3>Llamadas teléfonicas</h3>
                </div>
                <Link to='/client/calls'>
                  Ver más <img src={ArrowRight} />
                </Link>
              </div>
              {this.state.calls.length == 0 && (
                <div className='no-items'>
                  <p>No se encontraron registros</p>
                </div>
              )}
              {this.state.calls.map((item: any) => {
                const [start, end] = (item.hour || '').split(',');
                const toFormatStart = start ? moment(start, 'HH:mm').format('hh:mm A') : '';
                const toFormatEnd = end ? moment(end, 'HH:mm').format('hh:mm A') : '';
                const statusColor =
                  item.status === Constants.CALL_STATUS.RESOLVED
                    ? Colors.green
                    : item.status === Constants.CALL_STATUS.NO_RESOLVED
                      ? Colors.danger
                      : Colors.orange;
                return (
                  <div className='item' key={item.id}>
                    <div className='row'>
                      <div className='col-md-6'>
                        <p className='date' style={{ fontSize: '14px' }}>
                          {moment(item.day).format('DD/MM/YYYY')}
                        </p>
                      </div>
                      <div className='col-md-6'>
                        <p className='number' style={{ fontSize: '14px' }}>
                          ID {item.number}
                        </p>
                      </div>
                      <div className='col-md-12'>
                        <p className='date' style={{ fontSize: '12px', marginTop: '-10px' }}>
                          {toFormatStart} a {toFormatEnd}
                        </p>
                      </div>
                      <div className='col-md-8'>
                        {item.lawyer != null ? (
                          <div className='container-lawyer'>
                            <img
                              src={
                                item.lawyer?.photo
                                  ? Constants.BASE_STORAGE + item.lawyer?.photo
                                  : WhiteImage
                              }
                            />
                            <div className='container-name'>
                              <p className='bold' style={{ fontSize: '12px' }}>
                                Abogado
                              </p>
                              <p style={{ fontSize: '12px' }}>{item.lawyer?.full_name}</p>
                            </div>
                          </div>
                        ) : (
                          <div className='container-no-lawyer'>
                            <p>No se ha asignado abogado</p>
                          </div>
                        )}
                      </div>
                      <div className='col-md-4 text-right'>
                        <div className='container-status' style={{ backgroundColor: statusColor }}>
                          <p style={{ fontSize: '10px' }}>{item.status_text}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {this.state.plan_user && this.hasService(Constants.SERVICES.SIGN) && (
              <div className='container-white'>
                <div className='header-white'>
                  <div className='name-container'>
                    <div className='icon-container' style={{ backgroundColor: Colors.green }}>
                      <img src={MenuIcons.Menu7} />
                    </div>
                    <h3>Firma electrónica</h3>
                  </div>
                  <Link to='/client/signatures'>
                    Ver más <img src={ArrowRight} />
                  </Link>
                </div>
                <StatusCertificateCard
                  apacuanaUser={apacuanaUser}
                  history={this.props.history}
                  status={status}
                  cert={cert}
                  customer={customer}
                  onOpenGenerateForm={onOpenGenerateForm}
                  onOpenRevoqueForm={onOpenRevoqueForm}
                />
              </div>
            )}
          </div>
          <div className='col-md-4'>
            <div className='container-white full'>
              <div className='header-white' style={{ marginBottom: '10px' }}>
                <div className='name-container'>
                  <div className='icon-container' style={{ backgroundColor: Colors.blue }}>
                    <img src={MenuIcons.Menu5} />
                  </div>
                  <h3>Trámites automatizados</h3>
                </div>
                {this.state.plan_user ? (
                  <Link to='/client/formalities'>
                    Ver más <img src={ArrowRight} />
                  </Link>
                ) : (
                  <span
                    style={{
                      color: '#939090ff',
                      textDecoration: 'underline',
                      cursor: 'default',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    Ver más
                    <img
                      src={ArrowRight}
                      alt='Flecha'
                      style={{
                        width: '16px',
                        height: 'auto',
                        opacity: 0.6,
                      }}
                    />
                  </span>
                )}
              </div>
              {this.state.areas.map((item: any) => {
                return (
                  <button
                    className='btn btn-area'
                    disabled={!!!this.state.plan_user}
                    onClick={() => {
                      this.state.plan_user &&
                        this.props.history.push({
                          pathname: '/client/formalities',
                          state: {
                            area_id: item?.id,
                          },
                        });
                    }}
                  >
                    <div className='icon-container' style={{ backgroundColor: Colors.white }}>
                      <img src={AreaIcon} />
                    </div>
                    {item.name}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const HomeWithApacuana = (props: Props) => {
  const apacuanaContext: any = useApacuana();
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState(undefined);
  const [status, setStatus] = useState(undefined);
  const [cert, setCert] = useState(undefined);
  const [openGenerateForm, setOpenGenerateForm] = useState(false);
  const [openRevoqueForm, setOpenRevoqueForm] = useState(false);
  const [password, setPassword] = useState('');
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState('');

  const init = async () => {
    setLoading(true);

    if (apacuanaContext?.isInitialized) {
      try {
        if (apacuanaContext?.user?.apacuanaId) {
          const customer = await apacuanaContext?.sdk?.getCustomer();

          setCustomer(customer?.data?.userData);
        }
        const certTypesList = await apacuanaContext?.sdk?.getCertTypes();
        const certTypes = certTypesList?.data?.records || [];
        const currentCertType = certTypes.find(
          (el: any) => el.handler === CERTIFICATES_TYPES[apacuanaContext.user.level.name],
        );
        const certRequirements = await apacuanaContext?.sdk?.getCertRequerimentsByType({
          type: Number(currentCertType.id),
        });

        setCert({
          ...currentCertType,
          documents: certRequirements.data.records,
        });
        const status = await apacuanaContext?.sdk?.getCertStatus();
        setStatus(status?.data?.status);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const getRequestRevocations = async () => {
    setLoading(true);
    try {
      const response = await apacuanaContext?.sdk?.getRevocationReasons();
      setReasons(response.data.reasons);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const requestRevocations = async () => {
    setLoading(true);
    try {
      await apacuanaContext?.sdk?.requestRevocation({
        reasonCode: Number(selectedReason),
      });
      const status = await apacuanaContext?.sdk?.getCertStatus();
      setStatus(status?.data?.status);

      setOpenRevoqueForm(false);
      setReasons([]);
      setSelectedReason('');
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const generateCert = async () => {
    setLoading(true);
    try {
      await apacuanaContext?.sdk?.generateCert(password);
      const status = await apacuanaContext?.sdk?.getCertStatus();
      setStatus(status?.data?.status);
      setOpenGenerateForm(false);
      Globals.showSuccess(
        '¡Solicitud completada! Su certificado digital se encuentra en proceso de emisión.',
      );
    } catch (error) {
      console.error('Error al crear el usuario:', error);
    } finally {
      setLoading(false);
    }
  };

  const onOpenGenerateForm = () => {
    setOpenGenerateForm(true);
  };

  const onOpenRevoqueForm = () => {
    setOpenRevoqueForm(true);
  };

  useEffect(() => {
    if (loading) {
      Globals.setLoading();
    } else {
      Globals.quitLoading();
    }
  }, [loading]);

  useEffect(() => {
    init();
  }, [apacuanaContext?.isInitialized, apacuanaContext?.user?.apacuanaId]);

  useEffect(() => {
    if (openRevoqueForm) {
      getRequestRevocations();
    }
  }, [openRevoqueForm]);
  return (
    <>
      <Home
        {...props}
        apacuana={apacuanaContext}
        customer={customer}
        status={status}
        cert={cert}
        onOpenGenerateForm={onOpenGenerateForm}
        onOpenRevoqueForm={onOpenRevoqueForm}
      />
      {openGenerateForm && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header' style={{ background: '#fff' }}>
                <h5 className='modal-title'>Generación de certificado electrónico</h5>
                <span
                  className='btn-close'
                  onClick={() => setOpenGenerateForm(false)}
                  aria-label='Close'
                  style={{ fontWeight: 700, cursor: 'pointer' }}
                >
                  X
                </span>
              </div>

              <div className='modal-body' style={{ background: '#fff' }}>
                <div className='container-fluid'>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Debe ingresar una contraseña alfanumérica y guardarla de forma segura.
                  </p>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    La contraseña no se puede recuperar a través del sistema. Si la olvida, perderá
                    el acceso a su certificado y deberá solicitar la revocación.
                  </p>
                  <div>
                    <div className='col-md-12' style={{ padding: 0 }}>
                      <Input
                        maxLength={12}
                        type='password'
                        color='white'
                        name='phone_10'
                        label='Contraseña'
                        onChange={(e: any) => setPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <button
                    style={{
                      width: '100%',
                      backgroundColor: '#0777FF !important',
                      color: '#fff',
                    }}
                    type='button'
                    disabled={password.length < 8}
                    className={`btn btn-report ${'active'}`}
                    onClick={() => generateCert()}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openRevoqueForm && reasons.length > 0 && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              {/* HEADER */}
              <div className='modal-header' style={{ background: '#fff' }}>
                <h5 className='modal-title'>Solicitud de revocación de certificado electrónico</h5>
                <span
                  className='btn-close'
                  onClick={() => {
                    setOpenRevoqueForm(false);
                    setReasons([]);
                    setSelectedReason('');
                  }}
                  aria-label='Close'
                  style={{ fontWeight: 700, cursor: 'pointer' }}
                >
                  X
                </span>
              </div>

              {/* BODY */}
              <div className='modal-body' style={{ background: '#fff' }}>
                <div className='container-fluid'>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Al enviar la solicitud de revocación, su certificado digital queda
                    inmediatamente inactivo y no podrá utilizarse para firmar documentos hasta que
                    el proceso finalice.
                  </p>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Una vez que la solicitud sea completada, deberá generar un certificado nuevo
                    para reestablecer sus capacidades de firma.{' '}
                  </p>
                  <div>
                    <div className='col-md-12' style={{ padding: 0 }}>
                      <Select
                        label='Motivo'
                        color='white'
                        placeholder='Motivo de revocación'
                        name='bank_id'
                        onChange={(e: any) => setSelectedReason(e.target.value)}
                        value={selectedReason}
                        options={reasons.map((item: any) => {
                          return {
                            value: item.id,
                            label: item.reason,
                          };
                        })}
                      />
                    </div>
                  </div>

                  <button
                    style={{
                      width: '100%',
                      backgroundColor: '#0777FF !important',
                      color: '#fff',
                    }}
                    type='button'
                    disabled={selectedReason === ''}
                    className={`btn btn-report ${'active'}`}
                    onClick={() => requestRevocations()}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(HomeWithApacuana);

export { TYPES };
